<template>
  <div>
    <slot name="nav"></slot>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'TopNav',
};
</script>

<style scoped>

</style>
